import React from "react";
import SettingsModal from "../components/modals/settings";
import axios from "../utils/axiosConfig";
import ModalBaseSm from "./../components/modals/modal-base-sm";
import FormUpdatePassword from "../components/formsSolicitudes/formUpdatePassword";
import "../Pages/Css/navbarPrincipal.css";
import Swal from "sweetalert2";
import { getBrowserTimeZone, getCurrentTimeZoneData } from "../utils/timezones";

import {
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    Button,
    Input,
} from "reactstrap";

const server = localStorage.getItem("server");
const userName = localStorage.getItem("username");

class BarraSolicitud extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openModal: false,
            openModalChangePassword: false,

            // desktop dropdown
            showNotificationDropdown: false,

            // responsive
            isMobile: window.matchMedia("(max-width: 768px)").matches,

            // mobile offcanvas
            offcanvasSolicitudes: false,
            offcanvasUser: false,

            solicitudes: [],
            hasNewNotification: false,

            confirmacionIndex: null,
            animatingIndex: null,

            userSolicitud: localStorage.getItem("username"),

            bitOpen: false,
            bitInsert: false,
            bitEdit: false,
            bitDelete: false,

            audioReady: false,
            currentTime: new Date(),
        };

        this.dropdownRef = React.createRef();
        this.bellIconRef = React.createRef();

        this.socket = null;
        this.notificationSound = new Audio("/audio/notificationpush.mp3");

        this.logout = this.logout.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openModalChangePassword = this.openModalChangePassword.bind(this);
        this.closeModalChangePassword = this.closeModalChangePassword.bind(this);

        this.toggleNotificationDropdown = this.toggleNotificationDropdown.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.toggleOffcanvasSolicitudes = this.toggleOffcanvasSolicitudes.bind(this);
        this.toggleOffcanvasUser = this.toggleOffcanvasUser.bind(this);

        this.HandlePageByRole();
    }

    /* -------------------- responsive -------------------- */
    handleResize() {
        const isMobile = window.matchMedia("(max-width: 768px)").matches;

        this.setState((prev) => {
            const next = { isMobile };

            // si paso a desktop, cierro offcanvas
            if (!isMobile && (prev.offcanvasSolicitudes || prev.offcanvasUser)) {
                next.offcanvasSolicitudes = false;
                next.offcanvasUser = false;
            }

            // si paso a mobile, cierro dropdown
            if (isMobile && prev.showNotificationDropdown) next.showNotificationDropdown = false;

            return next;
        });
    }

    /* -------------------- offcanvas toggles -------------------- */
    toggleOffcanvasSolicitudes() {
        this.setState((prev) => ({
            offcanvasSolicitudes: !prev.offcanvasSolicitudes,
            hasNewNotification: false,
            showNotificationDropdown: false, // si abro offcanvas, cierro dropdown
        }));
    }

    openOffcanvasSolicitudes = () => {
        this.setState({
            offcanvasSolicitudes: true,
            hasNewNotification: false,
            showNotificationDropdown: false,
        });
    };

    closeOffcanvasSolicitudes = () => {
        this.setState({ offcanvasSolicitudes: false });
    };

    toggleOffcanvasUser() {
        this.setState((prev) => ({
            offcanvasUser: !prev.offcanvasUser,
            showNotificationDropdown: false,
        }));
    }

    openOffcanvasUser = () => {
        this.setState({
            offcanvasUser: true,
            showNotificationDropdown: false,
        });
    };

    closeOffcanvasUser = () => {
        this.setState({ offcanvasUser: false });
    };

    /* -------------------- audio -------------------- */
    handleUserInteraction = () => {
        this.setState({ audioReady: true });
        document.body.removeEventListener("click", this.handleUserInteraction);
    };

    playNotificationSound = () => {
        if (this.state.audioReady) {
            this.notificationSound.play().catch((error) => {
                console.error("Error al intentar reproducir el sonido:", error);
            });
        }
    };

    /* -------------------- ws -------------------- */
    connectSocket = () => {
        const token = localStorage.getItem("tkn");
        if (!token) return;

        if (this.socket) {
            try { this.socket.close(); } catch { }
        }

        this.socket = new WebSocket(
            `wss://${process.env.REACT_APP_SERVER_WEBSOCKET}/websocket/`,
            token
        );

        this.socket.onmessage = (event) => {
            const data = JSON.parse(event.data);

            if (data?.event === true) {
                this.props.onUpdateSolicitudes?.(data.data);

                const ordenado = (data.data || []).slice().sort((a, b) => {
                    const numA = parseInt(String(a.IDSolicitudes || "").split("-")[1] || "0", 10);
                    const numB = parseInt(String(b.IDSolicitudes || "").split("-")[1] || "0", 10);
                    return numB - numA;
                });

                // sonido/voz solo si tiene permisos
                if (this.state.bitOpen && ordenado.length > 0) {
                    this.playNotificationSound();
                    this.showNotificationSpeech(ordenado[0]);
                    this.setState({ hasNewNotification: true });
                }
            } else {
                console.error("Algo anda mal en el ws");
            }
        };

        this.socket.onerror = (error) => {
            console.error("Error en la conexión WebSocket:", error);
        };

        this.socket.onclose = () => {
            setTimeout(() => this.connectSocket(), 5000);
        };
    };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        window.addEventListener("resize", this.handleResize);
        this.clockIntervalId = window.setInterval(() => {
            this.setState({ currentTime: new Date() });
        }, 1000);

        const filterSolicitudes = (this.props.filteredSolicitudes || []).filter(
            (d) => d.estado === "Solicitud Cliente por Confirmar"
        );

        const ordenado = filterSolicitudes.slice().sort((a, b) => {
            const numA = parseInt(String(a.IDSolicitudes || "").split("-")[1] || "0", 10);
            const numB = parseInt(String(b.IDSolicitudes || "").split("-")[1] || "0", 10);
            return numB - numA;
        });

        this.setState({ solicitudes: ordenado });

        if ("Notification" in window) {
            Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                    document.body.addEventListener("click", this.handleUserInteraction);
                    this.connectSocket();
                }
            });
        }
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        window.removeEventListener("resize", this.handleResize);
        if (this.clockIntervalId) {
            window.clearInterval(this.clockIntervalId);
        }

        if (this.socket) this.socket.close();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filteredSolicitudes !== this.props.filteredSolicitudes) {
            const filterSolicitudes = (this.props.filteredSolicitudes || []).filter(
                (d) => d.estado === "Solicitud Cliente por Confirmar"
            );

            const ordenado = filterSolicitudes.slice().sort((a, b) => {
                const numA = parseInt(String(a.IDSolicitudes || "").split("-")[1] || "0", 10);
                const numB = parseInt(String(b.IDSolicitudes || "").split("-")[1] || "0", 10);
                return numB - numA;
            });

            this.setState({ solicitudes: ordenado });
        }
    }

    /* -------------------- speech -------------------- */
    showNotificationSpeech = (solicitud) => {
        if (!("speechSynthesis" in window) || !solicitud) return;

        const mensaje = `Nueva solicitud ${solicitud.NombreEmpresa}`;
        const utterance = new SpeechSynthesisUtterance(mensaje);
        utterance.lang = "es-ES";
        utterance.rate = 1;
        utterance.pitch = 1;

        const voices = window.speechSynthesis.getVoices();
        const maleVoice = voices.find(
            (v) => v.lang === "es-ES" && v.name.toLowerCase().includes("male")
        );
        if (maleVoice) utterance.voice = maleVoice;

        window.speechSynthesis.speak(utterance);
    };

    /* -------------------- dropdown desktop -------------------- */
    toggleNotificationDropdown() {
        this.setState((prev) => ({
            showNotificationDropdown: !prev.showNotificationDropdown,
            hasNewNotification: false,
            offcanvasSolicitudes: false, // si abre dropdown, cierro offcanvas
            offcanvasUser: false,
        }));
    }

    handleClickOutside(event) {
        // solo desktop
        if (this.state.isMobile) return;
        if (!this.state.showNotificationDropdown) return;

        if (
            this.dropdownRef.current &&
            this.bellIconRef.current &&
            !this.dropdownRef.current.contains(event.target) &&
            !this.bellIconRef.current.contains(event.target)
        ) {
            this.setState({ showNotificationDropdown: false });
        }
    }

    /* -------------------- permisos -------------------- */
    HandlePageByRole = async () => {
        const data = { pagina: "20" };
        try {
            const res = await axios.post(
                process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
                JSON.stringify(data),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            );

            if (res.data.success === false) {
                window.location.href = "/";
                return;
            }

            if (Array.isArray(res.data.data) && res.data.data.length > 0) {
                const row = res.data.data[0];
                this.setState({
                    bitOpen: !!row.bitOpen,
                    bitInsert: !!row.bitInsert,
                    bitEdit: !!row.bitEdit,
                    bitDelete: !!row.bitDelete,
                });
            }
        } catch (error) {
            console.error("Error al listar bit permisos:", error);
        }
    };

    /* -------------------- helpers -------------------- */
    getCurrentDateTime = () => {
        const now = new Date();
        const pad = (value) => String(value).padStart(2, "0");
        return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    };

    formatTimeForZone = (timeZone) => {
        try {
            return new Intl.DateTimeFormat("es-CO", {
                timeZone,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            }).format(this.state.currentTime);
        } catch {
            return "--";
        }
    };

    getTimePreviewData = () => {
        const activeZoneData = getCurrentTimeZoneData();
        const browserZone = localStorage.getItem("browser_time_zone") || getBrowserTimeZone();
        const activeZone = activeZoneData?.timeZone || browserZone;

        return {
            activeLabel: activeZoneData?.label || activeZone,
            activeTime: this.formatTimeForZone(activeZone),
            browserZone,
            browserTime: this.formatTimeForZone(browserZone),
        };
    };

    renderTimezonePreview = () => {
        const preview = this.getTimePreviewData();
        return (
            <div className="timezone-preview">
                <div className="timezone-preview-line">
                    <span className="timezone-preview-zone">{preview.activeLabel}</span>
                    <span className="timezone-preview-clock">{preview.activeTime}</span>
                </div>
            </div>
        );
    };

    handleAceptarClick = (index) => {
        if (this.state.bitInsert) {
            this.setState({ confirmacionIndex: index, animatingIndex: index });
        } else {
            Swal.fire({
                title: "Información",
                text: "No tiene los permisos necesarios para aceptar la solicitud",
                icon: "info",
                showConfirmButton: false,
                timer: 3000,
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
        }
    };

    handleConfirmarClick = (index) => {
        const solicitud = this.state.solicitudes[index];
        this.handleSolicitudClick(solicitud);
        this.setState({ confirmacionIndex: null, animatingIndex: null });
    };

    handleCancelarClick = () => {
        this.setState({ confirmacionIndex: null, animatingIndex: null });
    };

    handleSolicitudClick = (Solicitud) => {
        const fechaHora = this.getCurrentDateTime();

        const dataSolicitudReport = {
            FKLokEstadoID: 14,
            Nota: "",
            XTime: fechaHora,
            XUser: this.state.userSolicitud,
            FKLokSolicitudID: Solicitud.IDSolicitudes,
        };

        axios
            .post(
                process.env.REACT_APP_SERVER + "/solicitudes/setinsertReporteSolicitud",
                JSON.stringify(dataSolicitudReport),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            )
            .then((res) => {
                if (res.data.success === false) {
                    window.location = "/";
                } else {
                    this.props.ListarContratos?.();
                }
            })
            .catch((err) => console.error(err));
    };

    /* -------------------- auth/logout -------------------- */
    openModal() {
        this.setState({ openModal: true });
    }
    openModalChangePassword() {
        this.setState({ openModalChangePassword: true });
    }
    closeModalChangePassword() {
        this.setState({ openModalChangePassword: false });
    }
    closeModal() {
        this.setState({ openModal: false });
    }

    logout() {
        axios
            .get(process.env.REACT_APP_SERVER + "/logout", {
                headers: { "Content-Type": "application/json" },
                withCredentials: true,
            })
            .then(() => {
                localStorage.removeItem("tkn");
                localStorage.removeItem("username");
                localStorage.removeItem("companyId");
                localStorage.removeItem("server");
                localStorage.removeItem("isRefreshIntervalActive");
                localStorage.removeItem("project");
                localStorage.removeItem("idFilterSelected");
                localStorage.removeItem("arrayFilters");
                localStorage.removeItem("global_expansion_state");
                localStorage.removeItem("search");
                localStorage.removeItem("active_streams_v1");
                sessionStorage.removeItem("active_streams_v1");

                Object.keys(localStorage).forEach((key) => {
                    if (key.endsWith("_expanded")) localStorage.removeItem(key);
                });

                window.location = "/login";
            });
    }

    /* -------------------- UI: lista de solicitudes -------------------- */
    renderSolicitudesList = () => {
        const { solicitudes, confirmacionIndex } = this.state;

        if (!solicitudes || solicitudes.length === 0) {
            return (
                <p style={{ textAlign: "center", padding: 10, color: "#555" }}>
                    No tienes solicitudes por confirmar
                </p>
            );
        }

        return solicitudes.map((solicitud, index) => (
            <li
                key={index}
                className="dropdown-item cursor-pointer flex items-start justify-between solicitudesResponsive"
                style={{
                    padding: "8px 10px",
                    display: "flex",
                    gap: 10,
                    alignItems: "stretch",
                    listStyle: "none",
                }}
            >
                <span className="notification-dot"></span>

                <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
                    {confirmacionIndex === index ? (
                        <div
                            style={{
                                minHeight: 70,
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 10,
                                padding: "10px 0",
                                fontSize: 14,
                            }}
                        >
                            <span style={{ flex: "1 1 220px" }}>
                                ¿Confirmar aceptación de la solicitud?
                            </span>

                            <button
                                style={{ color: "green", background: "transparent", border: "none" }}
                                onClick={() => this.handleConfirmarClick(index)}
                            >
                                Confirmar
                            </button>

                            <button
                                style={{ color: "red", background: "transparent", border: "none" }}
                                onClick={this.handleCancelarClick}
                            >
                                Cancelar
                            </button>
                        </div>
                    ) : (
                        <>
                            <strong>{solicitud.IDSolicitudes}</strong>
                            <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {solicitud.NombreEmpresa}
                            </span>
                            <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {solicitud.Ruta}
                            </span>
                            <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {solicitud.nota}
                            </span>
                        </>
                    )}
                </div>

                {confirmacionIndex !== index && (
                    <button
                        className="btn-aceptar"
                        style={{
                            marginLeft: "auto",
                            padding: "4px 10px",
                            backgroundColor: "transparent",
                            color: "#006699",
                            border: "none",
                            cursor: "pointer",
                            borderLeft: "1px solid black",
                            whiteSpace: "nowrap",
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.handleAceptarClick(index);
                        }}
                    >
                        Aceptar
                    </button>
                )}
            </li>
        ));
    };

    render() {
        const totalCount = this.state.solicitudes?.length || 0;

        return (
            <>
                <nav
                    className="layout-navbar container-fluid navbar navbar-expand-xl align-items-center custom-navbar-admin platform-responsive-navbar"
                    id="layout-navbar"
                >
                    <a href="/principal" className="app-brand-link">
                        <img alt="" className="style22" src="./Cargotronics.png" height="80" />
                    </a>

                    <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
                        <ul className="navbar-nav flex-row align-items-center ms-auto navbar-actions">
                            {/* CAMPANA (Solicitudes) */}
                            {this.state.bitOpen && (
                                <li className="nav-item nav-notify">
                                    <button
                                        type="button"
                                        className="btn-reset"
                                        aria-label="Solicitudes"
                                        onClick={() =>
                                            this.state.isMobile
                                                ? this.openOffcanvasSolicitudes()
                                                : this.toggleNotificationDropdown()
                                        }
                                    >
                                        <i
                                            className={`bx bxs-bell-ring bx-md notification-icon ${this.state.hasNewNotification ? "bx-tada-hover-solicitudes" : ""
                                                }`}
                                            ref={this.bellIconRef}
                                        />
                                        <span className="notificationsCount">{totalCount}</span>
                                    </button>

                                    {/* DROPDOWN SOLO DESKTOP */}
                                    {!this.state.isMobile && this.state.showNotificationDropdown && (
                                        <ul
                                            className="dropdown-menu show"
                                            id="notificationDropdown"
                                            ref={this.dropdownRef}
                                            style={{
                                                position: "absolute",
                                                top: "100%",
                                                right: 0,
                                                width: 520,
                                                maxHeight: "calc(100vh - 200px)",
                                                overflow: "hidden",
                                                zIndex: 1000,
                                                backgroundColor: "#fff",
                                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                                borderRadius: 8,
                                                padding: 0,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: "sticky",
                                                    top: 0,
                                                    backgroundColor: "#fff",
                                                    zIndex: 2,
                                                    padding: 10,
                                                    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                                                }}
                                            >
                                                <h5
                                                    style={{
                                                        textAlign: "center",
                                                        margin: "0 0 10px",
                                                        fontWeight: "bold",
                                                        fontSize: "1rem",
                                                    }}
                                                >
                                                    Solicitudes sin atender
                                                </h5>
                                            </div>

                                            <div style={{ maxHeight: "calc(100vh - 300px)", overflowY: "auto", padding: 10 }}>
                                                <ul style={{ paddingLeft: 0, marginBottom: 0 }}>
                                                    {this.renderSolicitudesList()}
                                                </ul>
                                            </div>
                                        </ul>
                                    )}
                                </li>
                            )}

                            {/* USERNAME SOLO DESKTOP */}
                            <li className="nav-item d-none d-lg-block">
                                <span className="fw-semibold" style={{ marginRight: 6 }}>
                                    {userName || "John Doe"}
                                </span>
                            </li>

                            {/* AVATAR */}
                            <li className="nav-item navbar-dropdown dropdown-user dropdown nav-avatar">
                                {this.state.isMobile ? (
                                    <button
                                        type="button"
                                        className="btn-reset"
                                        onClick={this.openOffcanvasUser}
                                        aria-label="Abrir menú de usuario"
                                    >
                                        <img src="../assets/img/avatars/1.png" alt="avatar" className="avatar-img" />
                                    </button>
                                ) : (
                                    <>
                                        <a className="nav-link dropdown-toggle hide-arrow" data-bs-toggle="dropdown" href="#">
                                            <img src="../assets/img/avatars/1.png" alt="avatar" className="avatar-img" />
                                        </a>

                                        <ul className="dropdown-menu dropdown-menu-end">
                                            <li>
                                                <div className="dropdown-item">
                                                    <div className="d-flex">
                                                        <div className="flex-shrink-0 me-3" id="AvatarReponsive">
                                                            <div className="avatar avatar-online">
                                                                <img src="../assets/img/avatars/1.png" alt="" className="w-px-40 h-auto rounded-circle" />
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <span
                                                                className="fw-semibold d-block text-wrap"
                                                                style={{ maxWidth: 150, wordBreak: "break-all", whiteSpace: "normal" }}
                                                            >
                                                                {userName || "John Doe"}
                                                            </span>
                                                            <small className="text-muted">Admin</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>

                                            <li><div className="dropdown-divider"></div></li>
                                            <li>{this.renderTimezonePreview()}</li>
                                            <li><div className="dropdown-divider"></div></li>

                                            <li>
                                                <a className="dropdown-item" href="/myprofile">
                                                    <i className="bx bx-user me-2"></i>
                                                    <span className="align-middle">My Profile</span>
                                                </a>
                                            </li>

                                            <li>
                                                <a className="dropdown-item" href="/myprofile#timezone-settings">
                                                    <i className="bx bx-time-five me-2"></i>
                                                    <span className="align-middle">Zona horaria</span>
                                                </a>
                                            </li>

                                            <li>
                                                <button
                                                    type="button"
                                                    className="dropdown-item"
                                                    onClick={this.openModal}
                                                    data-bs-target="#ModalSettings"
                                                    data-bs-toggle="modal"
                                                >
                                                    <i className="bx bx-cog me-2"></i>
                                                    <span className="align-middle">Settings</span>
                                                </button>
                                            </li>

                                            <li>
                                                <button type="button" className="dropdown-item" onClick={this.openModalChangePassword}>
                                                    <i className="bx bx-lock me-2"></i>
                                                    <span className="align-middle">Cambiar contraseña</span>
                                                </button>
                                            </li>

                                            <li><div className="dropdown-divider"></div></li>

                                            <li>
                                                <button type="button" className="dropdown-item" onClick={this.logout}>
                                                    <i className="bx bx-power-off me-2"></i>
                                                    <span className="align-middle">Log Out</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </>
                                )}
                            </li>
                        </ul>
                    </div>
                </nav>

                {/* ✅ OFFCANVAS SOLICITUDES (MOBILE) */}
                <Offcanvas
                    isOpen={this.state.offcanvasSolicitudes}
                    toggle={this.toggleOffcanvasSolicitudes}
                    direction="end"
                    className="solicitudes-responsive-offcanvas"
                    style={{ width: "100vw", maxWidth: "100vw" }}
                >
                    <OffcanvasHeader toggle={this.toggleOffcanvasSolicitudes}>
                        Solicitudes
                    </OffcanvasHeader>

                    <OffcanvasBody style={{ paddingTop: 10 }}>
                        <div style={{ overflowY: "auto" }}>
                            <ul style={{ paddingLeft: 0, marginBottom: 0 }}>
                                {this.renderSolicitudesList()}
                            </ul>
                        </div>
                    </OffcanvasBody>
                </Offcanvas>

                {/* ✅ OFFCANVAS USER (MOBILE) */}
                <Offcanvas
                    isOpen={this.state.offcanvasUser}
                    toggle={this.toggleOffcanvasUser}
                    direction="end"
                    className="solicitudes-responsive-offcanvas"
                    style={{ width: "100vw", maxWidth: "100vw" }}
                >
                    <OffcanvasHeader toggle={this.toggleOffcanvasUser}>
                        Mi cuenta
                    </OffcanvasHeader>

                    <OffcanvasBody>
                        <div className="text-center mb-4">
                            <img
                                src="../assets/img/avatars/1.png"
                                alt="avatar"
                                className="rounded-circle mb-2"
                                width="72"
                            />
                            <h6 className="mb-0">{userName}</h6>
                            <small className="text-muted">Admin</small>
                        </div>

                        {this.renderTimezonePreview()}

                        <Button
                            color="light"
                            className="w-100 mb-2 text-start"
                            onClick={() => (window.location.href = "/myprofile")}
                        >
                            <i className="bx bx-user me-2"></i>
                            Mi perfil
                        </Button>

                        <Button
                            color="light"
                            className="w-100 mb-2 text-start"
                            onClick={() => (window.location.href = "/myprofile#timezone-settings")}
                        >
                            <i className="bx bx-time-five me-2"></i>
                            Zona horaria
                        </Button>

                        <Button
                            color="light"
                            className="w-100 mb-2 text-start"
                            onClick={this.openModal}
                            data-bs-toggle="modal"
                            data-bs-target="#ModalSettings"
                        >
                            <i className="bx bx-cog me-2"></i>
                            Configuración
                        </Button>

                        <Button
                            color="light"
                            className="w-100 mb-2 text-start"
                            onClick={this.openModalChangePassword}
                        >
                            <i className="bx bx-lock me-2"></i>
                            Cambiar contraseña
                        </Button>

                        <hr />

                        <Button color="light" className="w-100 text-start" onClick={this.logout}>
                            <i className="bx bx-power-off me-2"></i>
                            Cerrar sesión
                        </Button>
                    </OffcanvasBody>
                </Offcanvas>

                {/* Modals */}
                <div className="modal fade" id="settingsModal" data-bs-backdrop="static" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <p>Set</p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <SettingsModal isOpen={this.state.openModal} onClose={this.closeModal} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="ModalSettings" data-bs-backdrop="static" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <form className="modal-content" id="ModalSettings">
                            <div className="modal-header">
                                <h5 className="modal-title" id="backDropModalTitle">
                                    Base de datos: {server === "Prod" ? "Producción" : "Pruebas"}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={this.closeModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <SettingsModal isOpen={this.state.openModal} onClose={this.closeModal} />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <ModalBaseSm
                    isOpen={this.state.openModalChangePassword}
                    title={"Cambiar contraseña"}
                    onClose={this.closeModalChangePassword}
                    childComponent={<FormUpdatePassword onClose={this.closeModalChangePassword} />}
                />
            </>
        );
    }
}

export default BarraSolicitud;
